import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { AddressControls } from './builder/AddressFormBuilder';
import { FormGroup, ValidatorFn } from '@angular/forms';

import { FormGroupHelper } from './FormGroupHelper';
import { BaryAddressService } from '../../services/bary-address.service';
import { Transport } from '../transport.model';
import { IAddress } from '../address.model';
import { TransportMapper } from '../../app/shared/mapper/transport-mapper';
import { patchObject } from '../../app/shared/util/object-util';

export class AddressFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<AddressControls> {
  protected declare readonly form: FormGroup;
  name = 'addressForm';
  updated = false;
  controls: AddressControls;
  addressType: { pickup?: boolean; delivery?: boolean; address?: boolean } = { address: true };

  constructor(
    private baryAddressUtil: BaryAddressService,
    formName: string,
    addressType: {
      pickup?: boolean;
      delivery?: boolean;
      address?: boolean;
    },
    controls: AddressControls,
    validators?: ValidatorFn[]
  ) {
    super();
    this.addressType = addressType;
    this.name = formName;
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
  }

  value(): any {
    return this.form.value;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: any, overrideFullname = false): void {
    if (model instanceof Transport) {
      this.updateFormFromTransport(model);
    } else {
      this.updateFormFromAddress(model, overrideFullname);
    }
  }

  private updateFormFromAddress(address: IAddress, overrideFullname = false): void {
    const newVal = { ...address, autofill: this.baryAddressUtil.updateGmapsAddressString(address) ?? '' };
    if (!overrideFullname) {
      newVal.fullname = this.form.value.fullname ? this.form.value.fullname : address.fullname;
    }
    this.form.patchValue(newVal);
    this.updated = true;
  }

  private updateFormFromTransport(transport: Transport): void {
    let address: IAddress;
    if (this.addressType.pickup) {
      address = TransportMapper.getPickupAddress(transport);
    } else if (this.addressType.delivery) {
      address = TransportMapper.getDeliveryAddress(transport);
    }
    this.updateFormFromAddress(address!);
  }

  updateModel(model: IAddress | Transport): void {
    if (model instanceof Transport) {
      this.updateModelFromTransport(model);
    } else {
      this.updateModelFromAddress(model);
    }
  }

  private updateModelFromAddress(address: IAddress): void {
    patchObject(address, this.form.value);
  }

  private updateModelFromTransport(transport: Transport): void {
    patchObject(transport, this.form.value);
  }
}
